export const calculatePercentageChange = (oldValue, newValue) => {
    if (oldValue === null || oldValue === 0) {
        return 0;
    }
    let dif = newValue - oldValue;
    return (dif / oldValue) * 100;
}